<template>
  <v-card>
    <v-card-text>
      <v-subheader>SERVE</v-subheader>
      <v-alert v-if="assignment === '' && termStarted" type="info">You are not assigned to a SERVE area. Please contact the Student Development office if you are a new student and should be assigned somewhere.</v-alert>
      <v-alert v-else-if="assignment === ''" type="info" outlined>SERVE assignments have not yet been set. Please check back closer to the start of the term to find your assigned area.</v-alert>
      <template v-else>
        <v-row>
          <v-col>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Assigned Area:</v-list-item-subtitle>
                <v-list-item-title>{{ assignment }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col>
            <v-list-item v-if="assignment !== 'Off-Campus'">
              <v-list-item-content>
                <v-list-item-subtitle :href="'mailto:' + supervisorEmail" target="_blank">Supervisor</v-list-item-subtitle>
                <v-list-item-title>{{ supervisor || 'No Supervisor Specified' }}</v-list-item-title>
                <v-list-item-subtitle>{{ supervisorEmail }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Served Hours</v-list-item-subtitle>
                <v-list-item-title>{{ hours }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col v-if="committed > 0">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Committed Hours</v-list-item-subtitle>
                <v-list-item-title>{{ committed }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Target Hours</v-list-item-subtitle>
                <v-list-item-title>{{ target }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-progress-linear v-if="assignment !== ''" :value="(hours / target) * 100" />
    <v-card-actions v-if="assignment !== ''">
      <v-btn to="/serve" text>View Details</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'

function getTermText (term) {
  return (term.substring(4, 6) === '05' ? 'Spring ' : 'Fall ') + term.substring(0, 4)
}

export default {
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const termText = ref('')
    const termStarted = ref(false)
    const assignment = ref('')
    const target = ref(10)
    const hours = ref(0)
    const committed = ref(0)
    const supervisor = ref('')
    const supervisorEmail = ref('')

    onMounted(async () => {
      const dt = new Date()
      const start = new Date()
      start.setDate(start.getDate() + 21)
      const end = new Date()
      end.setDate(end.getDate() - 10)
      const { data: termData } = await root.$feathers.service('system/term').find({ query: { start: { $lte: start }, end: { $gte: end }, type: 'Traditional' } })
      if (termData.length > 0) {
        const term = termData[0].term
        termStarted.value = new Date(termData[0].start) <= dt
        const { data } = await root.$feathers.service('serve/student').find({ query: { pidm: user.value.pidm, term } })
        if (data.length > 0) {
          const rec = data[0]
          if (!('assignment' in rec && rec.assignment)) {
            assignment.value = ''
            return
          }
          assignment.value = rec.assignment
          termText.value = rec.term.map((t) => getTermText(t)).join('/')
          target.value = rec.target
          hours.value = rec.hours
          if (rec.assignment === 'Events') {
            const aggregate = [
              { $match: { term } },
              { $unwind: '$students' },
              { $match: { 'students.pidm': user.value.pidm, 'students.status': 'Committed' } },
              { $group: { _id: '$students.pidm', committed: { $sum: '$students.hours' } } }
            ]
            root.$feathers.service('serve/event').find({ query: { aggregate } }).then(({ data }) => {
              committed.value = data[0].committed
            })
          } else {
            root.$feathers.service('serve/area').find({ query: { area: assignment.value } }).then(({ data }) => {
              console.log(data)
              if (data.length > 0 && 'supervisors' in data[0] && Array.isArray(data[0].supervisors)) {
                supervisor.value = data[0].supervisors[0].name
                supervisorEmail.value = data[0].supervisors[0].email
              }
            })
          }
        }
      }
    })

    return {
      user,
      termText,
      assignment,
      target,
      hours,
      committed,
      supervisor,
      supervisorEmail
    }
  }
}
</script>
